import type { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import { ImagesViewPort } from '@/engine/app/modules/images/ImagesViewPort';
import type { SliceType } from '@/engine/app/modules/images/interfaces';
import { ReactComponent as MaximizeIcon } from '@/engine/app/modules/images/assets/largescreen.svg';
import type { IClippingManager } from '../../clipping/interfaces';
import { MaximizeIconWrapper } from '../MaximizeIconWrapper';
import styled from 'styled-components';

export interface IImageViewProps {
  descriptor: string;
  borderColor: string;
  sliceType: SliceType;
}

interface Props {
  isMaximized: boolean;
  imageView: IImageViewProps;
  maximize: () => void;
  minimize?: () => void;
  clippingManager?: IClippingManager;
  className?: string;
}

export const ImageViewPortWrapper: FC<Props> = ({
  isMaximized,
  maximize,
  minimize,
  imageView,
  clippingManager,
  className
}) => {
  const theme = useTheme();

  return (
    <Container className={className}>
      <ImagesViewPort
        style={{ height: '100%' }}
        bgColor={theme.customPalette.panels.images}
        isMaximized={isMaximized}
        descriptor={imageView.descriptor}
        sliceType={imageView.sliceType}
        clippingManager={clippingManager}
      />
      {!isMaximized && (
        <MaximizeButtonContainer>
          <MaximizeIconWrapper
            onClick={maximize}
            className="max-icon"
            data-testid={`maximize-2d-${imageView.descriptor}`}
          >
            <MaximizeIcon style={{ width: '30px', height: '30px' }} />
          </MaximizeIconWrapper>
        </MaximizeButtonContainer>
      )}
      {isMaximized && minimize && (
        <MaximizeButtonContainer>
          <MaximizeIconWrapper
            onClick={minimize}
            className="minimize-icon"
            data-testid={`minimize-2d-${imageView.descriptor}`}
          >
            <MaximizeIcon style={{ width: '30px', height: '30px' }} />
          </MaximizeIconWrapper>
        </MaximizeButtonContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  height: 100%;
  border-bottom: 1px solid transparent;
  *:last-child > & {
    border-bottom: none;
  }
`;

const MaximizeButtonContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;
